import { useGridApiContext, useGridSelector, useGridRootProps } from "@mui/x-data-grid-premium";
import { DataGridProProps, GridGroupNode, GridRenderCellParams, getDataGridUtilityClass, gridFilteredDescendantCountLookupSelector } from "@mui/x-data-grid-pro";
import { unstable_composeClasses as composeClasses } from "@mui/utils";
import { Box } from "@mui/material";
import { GridRenderCellParamsPremium } from "@mui/x-data-grid-premium/typeOverloads";
import CheckboxIndicator from "./CheckBoxIndicator";

type OwnerState = { classes: DataGridProProps["classes"] };

const useUtilityClasses = (ownerState: OwnerState) => {
    const { classes } = ownerState;

    const slots = {
        root: ["treeDataGroupingCell"],
        toggle: ["treeDataGroupingCellToggle"],
    };

    return composeClasses(slots, getDataGridUtilityClass, classes);
};

type GroupByColumnRenderCellProps = GridRenderCellParams & GridRenderCellParamsPremium & {
    offsetMultiplier?: number;
};

const  GroupByColumnRenderCell = (props: GroupByColumnRenderCellProps) => {
    const {
        id,
        field,
        formattedValue,
        rowNode,
        offsetMultiplier = 2,
    } = props;

    const rootProps = useGridRootProps();
    const apiRef = useGridApiContext();
    const ownerState = { classes: rootProps.classes };
    const classes = useUtilityClasses(ownerState);
    const filteredDescendantCountLookup = useGridSelector(
        apiRef,
        gridFilteredDescendantCountLookupSelector
    );

    const filteredDescendantCount =
        filteredDescendantCountLookup[rowNode.id] ?? 0;

    const Icon = (rowNode as GridGroupNode).childrenExpanded
        ? rootProps.slots.treeDataCollapseIcon
        : rootProps.slots.treeDataExpandIcon;

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        apiRef.current.setRowChildrenExpansion(id, !(rowNode as GridGroupNode).childrenExpanded);
        apiRef.current.setCellFocus(id, field);
        event.stopPropagation();
    };

    const value =
        formattedValue === undefined ? (rowNode as GridGroupNode).groupingKey : formattedValue;

    return (
        <Box className={classes.root} sx={{ ml: rowNode.depth * offsetMultiplier, justifyContent: 'space-between' }}>
            <div style={{display: 'flex'}}>
                <div className={classes.toggle}>
                    {filteredDescendantCount > 0 && (
                        <rootProps.slots.baseIconButton
                            size="small"
                            onClick={handleClick}
                            tabIndex={-1}
                            aria-label={
                                (rowNode as GridGroupNode).childrenExpanded
                                    ? apiRef.current.getLocaleText("treeDataCollapse")
                                    : apiRef.current.getLocaleText("treeDataExpand")
                            }
                            {...rootProps?.slotProps?.baseIconButton}
                        >
                            <Icon fontSize="inherit" />
                        </rootProps.slots.baseIconButton>
                    )}
                </div>
                <div style={{padding: '5px 0'}} title={value}>
                    {value}
                    {filteredDescendantCount > 0
                        ? ` (${filteredDescendantCount})`
                        : ""}
                </div>   
            </div>  
            <div style={{marginRight: '10px'}}>       
                {CheckboxIndicator(apiRef, props)}
            </div>
        </Box>
    );
}

export default GroupByColumnRenderCell;